var _path, _path2, _mask, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkloadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.125L11.9255 3.8932C11.5542 2.73817 11.3686 2.16065 10.9267 1.83032C10.4847 1.5 9.89775 1.5 8.7237 1.5H8.5263C7.35228 1.5 6.76527 1.5 6.32333 1.83032C5.8814 2.16065 5.69577 2.73817 5.3245 3.8932L5.25 4.125",
    stroke: "#546088",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25488 15.75H7.20409C4.51516 15.75 3.17069 15.75 2.33534 14.8988C1.5 14.0476 1.5 12.6776 1.5 9.9375C1.5 7.19746 1.5 5.82744 2.33534 4.97622C3.17069 4.125 4.51516 4.125 7.20409 4.125H10.0562C12.7451 4.125 14.0896 4.125 14.9249 4.97622C15.5676 5.63114 15.7158 6.59317 15.75 8.25",
    fill: "#B9BBC2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_4893_29230",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 10,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8,
    y: 8,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 14.2L13 13.4V11.4M9 13C9 15.2092 10.7908 17 13 17C15.2092 17 17 15.2092 17 13C17 10.7908 15.2092 9 13 9C10.7908 9 9 10.7908 9 13Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 14.2L13 13.4V11.4M9 13C9 15.2092 10.7908 17 13 17C15.2092 17 17 15.2092 17 13C17 10.7908 15.2092 9 13 9C10.7908 9 9 10.7908 9 13Z",
    fill: "#B9BBC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.4H12V13.9352L12.4453 14.2321L13 13.4ZM14.2 14.2L14.7547 13.3679L13.5547 12.568L13 13.4L12.4453 14.2321L13.6453 15.0321L14.2 14.2ZM13 13.4H14V11.4H13H12V13.4H13ZM9 13H8C8 15.7614 10.2386 18 13 18V17V16C11.3431 16 10 14.6569 10 13H9ZM13 17V18C15.7614 18 18 15.7614 18 13H17H16C16 14.6569 14.6569 16 13 16V17ZM17 13H18C18 10.2386 15.7614 8 13 8V9V10C14.6569 10 16 11.3431 16 13H17ZM13 9V8C10.2386 8 8 10.2386 8 13H9H10C10 11.3431 11.3431 10 13 10V9Z",
    fill: "white",
    mask: "url(#path-3-outside-1_4893_29230)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14L13 13.1429V11",
    stroke: "#546088",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadIc);
export default __webpack_public_path__ + "static/media/workload-ic.b0c3db103773e1f5482cf6deb5e67a19.svg";
export { ForwardRef as ReactComponent };